export default __webpack_public_path__ + "static/media/details.21fa13c4.svg";